import { render, staticRenderFns } from "./UserAdminActions.vue?vue&type=template&id=675658d4"
import script from "./UserAdminActions.vue?vue&type=script&lang=js"
export * from "./UserAdminActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports